import { AlertsSearchView } from "./alerts-search";
import { AlertsSearchModel } from "../models/alerts-search";
import { backboneViewProperties } from "../../decorators/backbone-properties";

@backboneViewProperties({
    tagName: "table",
    className: "alerts-search-list",
    childView: AlertsSearchView
})

export class AlertsSearchListView extends Marionette.CollectionView<AlertsSearchModel, AlertsSearchView> {
    constructor(options?) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/my-justis/views/alerts-search-list.ts